module.exports = __webpack_public_path__ + "img/team-1.497bb359.jpg";